import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue'

export type BaseImageProps = {
  src?: string;
  alt?: string;
  baseImageSrc?: string;
  loadingTime?: number;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseImage',
  props: {
    src: { default: '' },
    alt: { default: '' },
    baseImageSrc: { default: '' },
    loadingTime: { default: 5000 }
  },
  emits: ['error', 'success'],
  setup(__props: any, { emit }) {

const props = __props as { src: string, alt: string, baseImageSrc: string, loadingTime: number };





const image = ref<HTMLImageElement>()

onMounted(() => {
  if (!image.value) {
    return
  }

  const timeout = setTimeout(() => {
    image.value.onload = null
    image.value.onerror = null
    emit('error')
    image.value.src = props.baseImageSrc
  }, props.loadingTime)

  image.value.onload = () => {
    clearTimeout(timeout)
    emit('success')
  }

  image.value.onerror = () => {
    clearTimeout(timeout)
    emit('error')
    image.value.src = props.baseImageSrc
  }
})

return { __sfc: true,props, emit, image }
}

})